<script lang="ts">
  // import { createEventDispatcher } from 'svelte';
  import { endEvent } from '../stores';

  function quit() {
    console.log('sending quit event', $endEvent);
    window.parent.postMessage($endEvent, '*');
  //   parent.window.history.back();
  }
</script>

<div class="modal-wrapper">
  <div class="modal-inner-wrapper">
    <div class="title">Invalid Token!</div>

    <div class="content">
      <p>The token used in this request is invalid. </p>
      <p>If the problem persists, please contact support for assistance.</p>
    </div>

    <div class="buttons-wrapper mt4">
      <div on:click={quit}>Close</div>
    </div>
  </div>
</div>

<style>
  .modal-wrapper {
    /* border: 1px solid red; */
    background-color: rgba(0,0,0,0.75);
    position: fixed;
    align-items: center;
    display: flex;
    width: 100%;
    height: 100%;
    justify-content: center;
    z-index: 3999;
  }

  .modal-inner-wrapper {
    background-color: #ffc107; /* MTN Yellow */
    border-radius: 5px;
    color: black;
    width: 40rem;
    z-index: 4000;
  }

  .title {
    font-size: x-large;
    font-weight: bold;
    margin: 2rem;
  }

  .content {
    font-weight: normal;
    margin: auto 2rem;
  }

  .buttons-wrapper {
    display: flex;
    font-weight: bold;
    justify-content: space-evenly;
    margin: 2rem;
  }
  .buttons-wrapper div {
    background-color: #000;
    text-transform: uppercase;
    border-radius: 30px;
    padding: 5px 20px;
    color: #fff;
    cursor:pointer;
  }

</style>
